<template>
	<router-view>
		<!-- Vista router -->
	</router-view>
</template>

<script>
export default { };
</script>
